import React from 'react';
import { Element } from 'react-scroll';
import { 
  FaJs, FaPython, FaReact, FaNodeJs, FaGitAlt, 
  FaDatabase, FaCode, FaBrain, FaJava
} from 'react-icons/fa';
import { SiCplusplus, SiMongodb, SiPytorch } from 'react-icons/si';
import './Skills.css';

const Skills = () => {
  const skills = [
    { name: 'JavaScript', icon: <FaJs />, level: 'Advanced' },
    { name: 'Python', icon: <FaPython />, level: 'Beginner' },
    { name: 'C++', icon: <SiCplusplus />, level: 'Advanced' },
    { name: 'React.js', icon: <FaReact />, level: 'Advanced' },
    { name: 'Node.js', icon: <FaNodeJs />, level: 'Advanced' },
    { name: 'MongoDB', icon: <SiMongodb />, level: 'Intermediate' },
    { name: 'Java', icon: <FaJava />, level: 'Beginner' },
    { name: 'PyTorch', icon: <SiPytorch />, level: 'Beginner' },
    { name: 'Git', icon: <FaGitAlt />, level: 'Advanced' },
    { name: 'Machine Learning', icon: <FaBrain />, level: 'Intermediate' },
    { name: 'Data Structures', icon: <FaCode />, level: 'Advanced' },
    { name: 'SQL', icon: <FaDatabase />, level: 'Advanced' }
  ];

  return (
    <Element name="skills">
      <section className="skills">
        <div className="skills-container">
          <h2 className="section-title">My Skills</h2>
          <div className="skills-grid">
            {skills.map((skill, index) => (
              <div 
                key={index} 
                className="skill-card"
                data-aos="fade-up"
                data-aos-delay={index * 10}
              >
                <div className="skill-icon">
                  {skill.icon}
                </div>
                <h3>{skill.name}</h3>
                <span className={`skill-level ${skill.level.toLowerCase()}`}>
                  {skill.level}
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Element>
  );
};

export default Skills;
